module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/comment-item/comment-item.component.css
// module id = ./src/app/shared/components/comment-item/comment-item.component.css
// module chunks = main